export default __webpack_public_path__ + "static/media/logo.504930ab.png";